// swiper-initializer.js
import Swiper from 'swiper';
import { Navigation, Pagination } from "swiper/modules";


// Initialisation de Swiper pour les sliders non-Vue
export function initSwipers(container = document.getElementById('app')) {
    // Menu Swiper
    const menuSwiperElements = container.querySelectorAll('.menu-swiper:not(.swiper-initialized)');
    if (menuSwiperElements) {
        menuSwiperElements.forEach(element => {
            const swiper = new Swiper(element, {
                slidesPerView: "auto",
                freeMode: true,
                spaceBetween: 1,
                mousewheel: true,
                on: {
                    init: function() {
                        const swiperWrapper = this.el.querySelector('.swiper-wrapper');
                        if (swiperWrapper) {
                            // Vérifier si le contenu total est plus petit que le container
                            const totalWidth = this.slides.reduce((sum, slide) => sum + slide.offsetWidth, 0);
                            const containerWidth = this.el.offsetWidth;

                            if (totalWidth <= containerWidth) {
                                // centrer le contenu si pas de swipe possible
                                swiperWrapper.classList.add('justify-center');
                            }
                            else {
                                swiperWrapper.parentElement.classList.add('swiper-container--with-arrow');
                            }
                        }
                    }
                }
            });
        });
    }

    // Col article Swiper
    const colSwiperElements = container.querySelectorAll('.swiper-col:not(.swiper-initialized)');
    if (colSwiperElements) {
        colSwiperElements.forEach(element => {
            const wrapper = element.closest('.swiper-design-article-wrapper');
            const nextButton = wrapper ? wrapper.querySelector('.swiper-design-article-next') : null;
            const prevButton = wrapper ? wrapper.querySelector('.swiper-design-article-prev') : null;
            const navigation = nextButton && prevButton ? {
                nextEl: nextButton,
                prevEl: prevButton,
            } : {};
            const isSwiper = window.innerWidth < 1400;
            // Détecter le débordement
            if (isSwiper) {
                new Swiper(element, {
                    modules: [Navigation],
                    navigation,
                    slidesPerView: 'auto',
                    autoHeight: false,
                    spaceBetween: 15,
                    freeMode: true
                });
            } else {
                // Desktop : toujours initialiser avec 5 colonnes
                new Swiper(element, {
                    modules: [Navigation],
                    navigation,
                    slidesPerView: 6,
                    autoHeight: false,
                    spaceBetween: 18
                });
            }
        });
    }


    // Le Mag Swiper
    const leMagSwiperElements = container.querySelectorAll('.le-mag-swiper:not(.swiper-initialized)');
    if (leMagSwiperElements) {
        leMagSwiperElements.forEach(element => {
            const parentContainer = element.closest('.le-mag-block');
            const nextButton = parentContainer.querySelector('.swiper-le-mag-after');
            const prevButton = parentContainer.querySelector('.swiper-le-mag-before');
            console.log(nextButton);
            new Swiper(element, {
                modules: [Navigation],
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                slidesPerView: "auto",
                watchSlidesProgress: true,
                spaceBetween: 15
            });
        });
    }

    const embedSliderSwiperElements = container.querySelectorAll('.embed-slider:not(.swiper-initialized)');
    if (embedSliderSwiperElements) {
        embedSliderSwiperElements.forEach(element => {
            const parentContainer = element.closest('.embed-slider-container');
            const nextButton = parentContainer.querySelector('.swiper-button-next');
            const prevButton = parentContainer.querySelector('.swiper-button-prev');
            new Swiper(element, {
                modules: [Navigation, Pagination],
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                slidesPerView: "auto",
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return `<span class="${className} bg-primary"></span>`;
                    }
                },
                autoHeight: false,
                spaceBetween: 15
            });
        });
    }
}

// Initialisation au chargement et configuration de l'observer
export function setupSwiperWithObserver() {
    const appElement = document.getElementById('app');
    if (!appElement) {
        console.error("L'élément #app est introuvable");
        return;
    }
    initSwipers(appElement);

    // Observer les changements et relancer Swiper
    const observer = new MutationObserver(() => {
        initSwipers(appElement); // Réinitialiser Swiper si du contenu AJAX est ajouté
    });

    observer.observe(appElement, { childList: true, subtree: true });
}
